import React, { useEffect, useState } from 'react';
import { Box, Typography, Container, Button, CircularProgress } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

export const PaymentSuccess = () => {
    const navigate = useNavigate();
    const { user } = useAuth();
    const [verifying, setVerifying] = useState(true);

    useEffect(() => {
        const verifySubscription = async () => {
            if (!user?.email) {
                navigate('/');
                return;
            }

            try {
                // Verify the subscription status in Firebase
                const userRef = doc(db, 'users', user.email);
                const userDoc = await getDoc(userRef);

                if (!userDoc.exists()) {
                    navigate('/');
                    return;
                }

                const userData = userDoc.data();

                // Check if subscription was recently updated (within last 5 minutes)
                const subscriptionUpdated = userData.subscription_updated_at;
                if (!subscriptionUpdated) {
                    navigate('/pricing');
                    return;
                }

                const updateTime = new Date(subscriptionUpdated).getTime();
                const now = new Date().getTime();
                const fiveMinutes = 5 * 60 * 1000;

                if (now - updateTime > fiveMinutes) {
                    // Subscription update too old, might be invalid
                    navigate('/pricing');
                    return;
                }

                setVerifying(false);
            } catch (error) {
                console.error('Error verifying subscription:', error);
                navigate('/pricing');
            }
        };

        verifySubscription();
    }, [user, navigate]);

    if (verifying) {
        return (
            <Container maxWidth="sm">
                <Box sx={{
                    mt: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}>
                    <CircularProgress />
                    <Typography sx={{ mt: 2 }}>
                        Verifying your subscription...
                    </Typography>
                </Box>
            </Container>
        );
    }

    return (
        <Container maxWidth="sm">
            <Box sx={{
                mt: 8,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}>
                <CheckCircle color="success" sx={{ fontSize: 64, mb: 2 }} />
                <Typography variant="h4" gutterBottom>
                    Payment Successful!
                </Typography>
                <Typography align="center" color="text.secondary" paragraph>
                    Thank you for your subscription. Your account has been upgraded and your new email limits are now active.
                </Typography>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => navigate('/dashboard')}
                >
                    Go to Dashboard
                </Button>
            </Box>
        </Container>
    );
};

export default PaymentSuccess;